import { get } from 'lodash';
const root = state => get(state, 'UsageState.createEditUsage');

export const getUsageItems = state => get(root(state), 'usageItems', []);
export const getFetchUsageItems = state =>
  get(root(state), 'fetchUsageItems', false);
export const getFetchUsageDetailError = state =>
  get(root(state), 'fetchUsageDetailError', null);
export const getSelectedUsageDetail = state =>
  get(root(state), 'selectedUsageDetail', null);
export const getFetchingUsageDetail = state =>
  get(root(state), 'fetchingUsageDetail', false);
export const getUsageItemsLoadingError = state =>
  get(root(state), 'usageItemsLoadingError', null);
export const getSubmitted = state => get(root(state), 'submitted', false);
export const getSubmitError = state => get(root(state), 'submitError', null);
export const getSubmitting = state => get(root(state), 'submitting', false);
export const getLoading = state => get(root(state), 'loading', false);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/state/CreateEditUsage/selectors.js